import {atomWithSuspenseQuery} from "jotai-tanstack-query";
import {postRequestRBAC} from "../api/postRequestRBAC";
import {atom, PrimitiveAtom, useAtomValue} from "jotai";
import {User} from "@firebase/auth/dist/auth-public";

// Atom to store the current user
export const userAtom = atom<User | null | undefined>(undefined) as PrimitiveAtom<
    User | null | undefined
>;

// Suspense query atom for fetching permissions and roles
export const permissionsRolesAtom = atomWithSuspenseQuery<{
    permissions: string[][],
    roles: string[]
}>((get) => {
    const user = get(userAtom);

    return {
        queryKey: ['permissions', user?.uid],
        queryFn: async () => {
            if (!user) {
                console.log(`1 Fetching permissions and roles for user: ${user?.uid}`);
                return {permissions: [], roles: []};
            }
            console.log(`2 Fetching permissions and roles for user: ${user?.uid}`);
            const response = await postRequestRBAC(`/api/casbin/permissions_roles`);
            console.log(`3 Fetching permissions and roles for user: ${user?.uid}`, {response});
            return response.data || {permissions: [], roles: []};
        },
        enabled: !!user, // Only run query if user exists
    };
});

// Helper atoms for authorization checks
export const useCan = () => {
  const {
    data: { permissions },
  } = useAtomValue(permissionsRolesAtom)

  return (action: string, object: string) => {
    if (!permissions) return false

    for (const permission of permissions) {
      const permAction = permission[2]
      const permObject = permission[1]
      if (permAction === action && permObject === object) {
        return true
      }
    }

    return false
  }
}



export const useIsRole = () => {
    const {data: {permissions, roles}} = useAtomValue(permissionsRolesAtom);

    return (role: string) => {
        if (!roles) return false;

        for (const r of roles) {
            if (r === role) {
                return true;
            }
        }

        return false;
    }
};

// Authorization status atom
// export const authorizingAtom = atom(true);